import { HttpStatusCode } from 'axios';

export const HttpStatusText: { [key: string]: number } = {
  ERR_FR_TOO_MANY_REDIRECTS: HttpStatusCode.TooManyRequests,
  ERR_BAD_OPTION_VALUE: HttpStatusCode.BadRequest,
  ERR_BAD_OPTION: HttpStatusCode.BadRequest,
  ERR_NETWORK: HttpStatusCode.TooManyRequests,
  ERR_FAILED: HttpStatusCode.TooManyRequests,
  ERR_DEPRECATED: HttpStatusCode.BadRequest,
  ERR_BAD_RESPONSE: HttpStatusCode.BadRequest,
  ERR_BAD_REQUEST: HttpStatusCode.BadRequest,
  ERR_NOT_SUPPORT: HttpStatusCode.BadRequest,
  ERR_INVALID_URL: HttpStatusCode.BadRequest,
  ERR_CANCELED: HttpStatusCode.BadRequest,
  ECONNABORTED: HttpStatusCode.RequestTimeout,
  ETIMEDOUT: HttpStatusCode.RequestTimeout,
};

export const ErrorMessage: { [key: string]: string } = {
  'Usuário e/ou senha inválidos.': 'Senha incorreta. Tente novamente.',
  'O login e/ou senha informados sao invalidos.': 'Senha incorreta. Tente novamente.',
  DEFAULT: 'Tivemos um problema com a autenticação de senha. Tente novamente mais tarde.',
};
